export const isCheckInDateValid = (checkInDate, minDate, maxDate) => {
    const checkIn = new Date(checkInDate);
    const min = new Date(minDate);
    const max = new Date(maxDate);

    return checkIn >= min && checkIn <= max;
};